import { useEffect, useState } from 'react';

/** Whole seconds left until `at`, ticking once a second; 0 once it has passed or with no `at`. */
const useSecondsUntil = (at: number | null): number => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (at === null) return undefined;

    setNow(Date.now());

    const timer = window.setInterval(() => {
      const current = Date.now();

      setNow(current);
      if (current >= at) window.clearInterval(timer);
    }, 1000);

    return () => window.clearInterval(timer);
  }, [at]);

  return at === null ? 0 : Math.max(0, Math.ceil((at - now) / 1000));
};

export default useSecondsUntil;
